import { render } from "./BasicPill.vue?vue&type=template&id=90562684&scoped=true"
import script from "./BasicPill.vue?vue&type=script&lang=js"
export * from "./BasicPill.vue?vue&type=script&lang=js"

import "./BasicPill.vue?vue&type=style&index=0&id=90562684&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-90562684"

export default script